// TransferCashToBca.jsx
import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../helper/api';
import TransferCashToBank from './components/TransferCashToBank';
import IncomeOutsideOrders from './components/IncomeOutsideOrders';
import ExpenseForm from './components/ExpenseForm';

const CashToBank = () => {
    const [token, setToken] = useState('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenParam = urlParams.get('token');
        if (tokenParam) {
            setToken(tokenParam);
        } else {
            alert('Token tidak ditemukan di URL!');
        }
    }, []);

    if (!token) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
                <div className="text-center">
                    <p className="text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className='flex-col'>
                <TransferCashToBank token={token} />
                <IncomeOutsideOrders token={token} />
                <ExpenseForm token={token} />
            </div>
        </div>
    );
};

export default CashToBank;
